/**
 *
 * @param {Immutable.Map} field - field in immutable format
 * @param {string} errorType - attr that throw error
 * @param {*} message - error description
 * @returns
 */
export const getValidateError = (field, errorType, message) => ({
  fieldId: String(field.get('id') || 'Not specified'),
  errorType,
  fieldUuid: field.get('uuid') || null,
  message,
});
